// LIBRARIES
import styled from "styled-components";

// MISC

import {
  BORDER_RADIUS,
  COLORS,
  FONT_FAMILY,
  FONT_WEIGHT,
  MARGIN,
  SIZE,
} from "constants/variables";

//ASSETS
import cursorIcon from "assets/img/Cursor.png";

export const Button = styled.button<{ $active: boolean; $biggerCursor: boolean }>`
  background-color: ${({ $active }) => $active ? COLORS.Crimson : "transparent"};
  border: none;
  padding: 12px 16px;
  font-size: 16px;
  border-radius: ${BORDER_RADIUS.radius40};
  cursor: ${({ $biggerCursor }) => $biggerCursor ? `url(${cursorIcon}), auto` : "pointer"};
  color: ${COLORS.Yellow};
  transition: background-color 160ms ease-out, color 160ms ease-out;

  @media (hover: hover) {
    &:hover {
      background-color: ${({ $active }) => $active ? COLORS.FaluRed : COLORS.Yellow};
      color: ${({ $active }) => $active ? COLORS.Yellow : COLORS.RaisinBlack};
    }
  }

  &:active {
    background-color: ${({ $active }) => $active ? COLORS.FaluRed : COLORS.Orange};
    color: ${({ $active }) => $active ? COLORS.Yellow : COLORS.RaisinBlack};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.Yellow};
    outline-offset: 3px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const HeaderContainer = styled.header<{ $hasSectionNavigation?: boolean }>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  /* height: 100px; */
  height: 80px;
  align-items: center;
  padding: ${SIZE.max28} ${MARGIN.max80};
  position: relative;
  background-color: ${COLORS.VividAuburn};
  border-bottom-left-radius: ${({ $hasSectionNavigation }) => $hasSectionNavigation ? "0" : BORDER_RADIUS.radius24};
  border-bottom-right-radius: ${({ $hasSectionNavigation }) => $hasSectionNavigation ? "0" : BORDER_RADIUS.radius24};
  box-shadow: ${({ $hasSectionNavigation }) => $hasSectionNavigation ? "none" : `0px 4px 10px ${COLORS.boxShadow}`};
  z-index: 1000 !important;
  @media (max-width: 1300px) {
    padding: ${SIZE.max28} ${MARGIN.max56};
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 8px;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
`;

export const LogoText = styled.p`
  font-family: ${FONT_FAMILY.poppins};
  color: ${COLORS.Yellow};
  white-space: pre-wrap;
  font-weight: ${FONT_WEIGHT.semiBold};
  line-height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: ${SIZE.max16};
  justify-self: flex-start;
`;

export const CenterButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  margin-left: 10px;
  @media (max-width: 1500px) {
    gap: ${SIZE.max32};
  }
  @media (max-width: 1300px) {
    gap: ${SIZE.max24};
  }
`;

export const CenterComponentWrapper = styled.div`
  height: 50px;
`;

export const Logo = styled.img`
  height: 50px;
  width: 50px;
`;

export const RightButtonsWrapper = styled.div``;

export const ButtonsBarContainer = styled.div``;
